exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.issue-container[data-v-18108a4f] {\r\n    padding-top: 0px !important;\r\n    padding-bottom: 0px !important;\n}\n.create-issue-container[data-v-18108a4f] {\r\n    padding-top: 15px;\r\n    padding-right: 10px;\r\n    float: right !important;\n}\n.log-container[data-v-18108a4f] {\r\n    overflow-y: scroll;\r\n    max-height: 293px;\n}\n.review-issues-container[data-v-18108a4f] {\r\n    height: 361px;\n}\n.no-issues-container[data-v-18108a4f] {\r\n    -ms-flex-item-align: center;\r\n        align-self: center;\r\n    margin-top: 100px;\r\n    font-weight: 400;\n}\n.icon-style[data-v-18108a4f] {\r\n    color: white;\n}\r\n", ""]);

// exports
